import { render, staticRenderFns } from "./MetricWithIcon.vue?vue&type=template&id=4e8f3f06&"
import script from "./MetricWithIcon.vue?vue&type=script&lang=ts&"
export * from "./MetricWithIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports